module.exports = __webpack_public_path__ + "8e9b0b8ede1ae98292a56fe5312c2a34.MP3";